import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';

class FacilityOption extends Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }
    onClick(e){
        const {onClick} = this.props;
        onClick(e, {...this.props});
    }
    render() {
        const {facility, rate} = this.props;
        
        return (
            <div className={`option ${facility.selected ? 'selected' : ''}`} onClick={this.onClick}>
                <div>{facility.name}</div>
                <div>{facility.address}</div>
                <div>{`Total: ${numeral(rate).format('$0,0')}`}</div>
            </div>
        );
    }
}

FacilityOption.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default FacilityOption;